import * as yup from 'yup';
import { test5erSteps } from '@/features/Sparten/pkv/schema/schema';
import { hasKrankenhaustagegeldSelected } from '@/features/Sparten/pkv/formConfigs/sharedRenderConditions';

export const krankenhaustagegeldOptionenSchema = yup.object({
  betrag: yup
    .number()
    .max(500)
    .nullable()
    .default(null)
    .test('stepTests', 'Eingabe nur in Fünferschritten', (val) =>
      test5erSteps(val),
    )
    .when({
      is: () => hasKrankenhaustagegeldSelected(),
      then: yup.number().required(),
    }),
});
